import { useQueryParam } from 'use-query-params';
import { BooleanQueryParam } from 'root/src/client/v2/queryParams/helpers/params.helper';
export const useOnboardingQueryParam = () => {
    return useQueryParam('onboarding', BooleanQueryParam());
};
